import { FormControl, styled } from "@mui/material";

export const Styled = {
    FormControl: styled(FormControl)`
        & .MuiInputBase-root {
            border-radius: 0;
            line-height: 0;
        }
        & .MuiInputBase-root > fieldset {
            border: none;
            border-radius: 0;
        }
        & .MuiInputBase-root #transaction-status-select {
            padding: 0px;
        }
        & .MuiInputBase-root > svg {
            display: none;
        }
    `,
};
